export const DNA_KIT_REDUCER_NAMESPACE = "dnaKitReducer";
